// extracted by mini-css-extract-plugin
export default {"carousel-arrow":"cP7Xb","arrow-button":"WecPv","arrow-next":"tzVVl","arrow-prev":"MnN7Z","hide":"pfK7o"};